import { render, staticRenderFns } from "./itemwithdetaillist.vue?vue&type=template&id=58790c80&"
import script from "./itemwithdetaillist.vue?vue&type=script&lang=js&"
export * from "./itemwithdetaillist.vue?vue&type=script&lang=js&"
import style0 from "./itemwithdetaillist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports